import { createPortal } from 'react-dom';

export const Portal = ({ children }) =>
  createPortal(
    children,
    document.getElementById('root') ||
      document.getElementById('main_portal_target') ||
      document.body
  );
